import React, { useEffect } from "react";
import * as Icons from "react-feather";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "store/auth";

export default function MainMenu() {
  const location = useLocation();
  const [activeMenu] = location.pathname.slice(1).split("/");
  const auth = useAuth();

  return (
    <>
      <nav className="top-nav" style={{ zIndex: 999 }}>
        <ul>
          {auth.userMeta &&
            auth.userMeta.panel_menus &&
            auth.userMeta.panel_menus.length > 0 &&
            auth.userMeta.panel_menus.map((item, index) => {
              if (!item.allow) return null;
              const isActive = activeMenu === item.to.slice(1).split("/")[0];

              return (
                <li key={`item_${index}_${item.icon}`}>
                  <Link
                    to={item.to}
                    className={`top-menu ${isActive ? "top-menu--active" : ""}`}
                  >
                    <div className="top-menu__icon">
                      <IconLoader name={item.icon} />
                    </div>
                    <div className="top-menu__title">
                      {item.title}
                      {item.notification_count > 0 && (
                        <span
                          style={{
                            display: "block",
                            width: 20,
                            height: 20,
                            borderRadius: "100%",
                            backgroundColor: "red",
                            fontSize: 12,
                            padding: 3,
                            margin: 3,
                            color: "white",
                          }}
                        >
                          {item.notification_count}
                        </span>
                      )}
                      {item.childs.length > 0 && (
                        <Icons.ChevronDown className="top-menu__sub-icon" />
                      )}
                    </div>
                  </Link>

                  <ul className="">
                    {item.childs &&
                      item.childs.length > 0 &&
                      item.childs.map((c_item, c_index) => {
                        if (!c_item.allow) return null;

                        return (
                          <li key={`child_${index}_${c_index}_${c_item.to}`}>
                            <Link to={c_item.to} className="top-menu">
                              <div className="top-menu__icon">
                                <IconLoader name={c_item.icon} />
                              </div>
                              <div className="top-menu__title">
                                {c_item.title}
                                {c_item.notification_count > 0 && (
                                  <span
                                    style={{
                                      display: "block",
                                      width: 20,
                                      height: 20,
                                      borderRadius: "100%",
                                      backgroundColor: "red",
                                      fontSize: 12,
                                      padding: 3,
                                      margin: 3,
                                      color: "white",
                                    }}
                                  >
                                    {c_item.notification_count}
                                  </span>
                                )}
                              </div>
                            </Link>
                          </li>
                        );
                      })}
                  </ul>
                </li>
              );
            })}
        </ul>
      </nav>
    </>
  );
}

const IconLoader = (props) => {
  const Dicn = Icons[props.name];
  return Dicn ? <Dicn {...props.rest} /> : null;
};
